export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 11_21.bce955a5.jpg";